import { SET_GROUPS_ROLES, SET_CURRENT_GROUPS_ROLES_WITH_LEVEL, RESET_GROUPS_ROLES, } from './constants';
const INITIAL_STATE = {
    allGroupsRoles: null,
    currentGroupsRoles: null,
    currentGroupsRolesWithLevel: null,
};
const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_GROUPS_ROLES:
            return {
                ...state,
                currentGroupsRolesWithLevel: [{ groupId: action.payload[0] }],
                allGroupsRoles: action.payload,
            };
        case SET_CURRENT_GROUPS_ROLES_WITH_LEVEL:
            return {
                ...state,
                currentGroupsRolesWithLevel: action.payload,
            };
        case RESET_GROUPS_ROLES:
            return INITIAL_STATE;
        default:
            return state;
    }
};
export default reducer;
